import { useState, useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useAuth } from '@/lib/auth-context';

import { useLogout } from '@/hooks/useLogout';

import { useAssignments } from '@/hooks/useAssignments';

import { PageHeader } from '@/components/PageHeader';

import { NotificationBell } from '@/components/NotificationBell';

import { StatsCard } from '@/components/StatsCard';

import { SearchInput } from '@/components/SearchInput';

import { PaginatedListFooter } from '@/components/PaginatedListFooter';

import { StatusBadge } from '@/components/StatusBadge';

import { Button } from '@/components/ui/button';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import {

  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,

} from '@/components/ui/table';

import { ClipboardList, CheckCircle, Eye, Stethoscope, ListTodo } from 'lucide-react';

import { format } from 'date-fns';



export function DoctorDashboard() {

  const { user } = useAuth();

  const handleLogout = useLogout();

  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState('');

  const [page, setPage] = useState(1);

  const { assignments, total, statusCounts, loading, pageSize } =
    useAssignments(searchQuery || undefined, page);



  useEffect(() => {

    setPage(1);

  }, [searchQuery]);



  const stats = {

    pending: statusCounts.pending,

    inReview: statusCounts.inReview,

    submitted: statusCounts.submitted,

  };



  return (

    <div className="min-h-screen bg-gray-50">

      <PageHeader

        title="Patch Validation"

        subtitle="My assignments"

        icon={<Stethoscope className="size-6 text-green-600" />}

        iconBgClass="bg-green-100"

        actions={<NotificationBell />}

        userName={user?.name}

        userRole={user?.role ?? undefined}

        onLogout={handleLogout}

      />



      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">

          <StatsCard title="Pending" value={stats.pending} icon={<ListTodo className="size-4 text-blue-600" />} description="Not started" />

          <StatsCard title="In progress" value={stats.inReview} icon={<ClipboardList className="size-4 text-amber-600" />} description="Reviewing patches" />

          <StatsCard title="Submitted" value={stats.submitted} icon={<CheckCircle className="size-4 text-green-600" />} description="Completed reviews" />

        </div>



        <div className="mb-6">

          <SearchInput value={searchQuery} onChange={setSearchQuery} placeholder="Search by sample name…" />

        </div>



        <Card>

          <CardHeader><CardTitle>Assigned samples</CardTitle></CardHeader>

          <CardContent>

            <div className="overflow-x-auto">

              <Table>

                <TableHeader>

                  <TableRow>

                    <TableHead>Sample</TableHead>

                    <TableHead className="hidden md:table-cell">Assigned</TableHead>

                    <TableHead>Patches</TableHead>

                    <TableHead>Status</TableHead>

                    <TableHead className="text-right">Actions</TableHead>

                  </TableRow>

                </TableHeader>

                <TableBody>

                  {loading ? (

                    <TableRow><TableCell colSpan={5} className="text-center py-8 text-gray-500">Loading…</TableCell></TableRow>

                  ) : assignments.length === 0 ? (

                    <TableRow><TableCell colSpan={5} className="text-center py-8 text-gray-500">No assignments yet</TableCell></TableRow>

                  ) : (

                    assignments.map((a) => (

                      <TableRow key={a.id}>

                        <TableCell className="font-medium">{a.sample_name}</TableCell>

                        <TableCell className="hidden md:table-cell text-sm text-gray-500">

                          {format(new Date(a.assigned_at), 'MMM d, yyyy')}

                        </TableCell>

                        <TableCell>{a.total_patches}</TableCell>

                        <TableCell><StatusBadge status={a.status} /></TableCell>

                        <TableCell className="text-right">

                          <Button variant="ghost" size="sm" onClick={() => navigate(`/doctor/assignments/${a.id}`)}>

                            <Eye className="size-4" />

                          </Button>

                        </TableCell>

                      </TableRow>

                    ))

                  )}

                </TableBody>

              </Table>

            </div>

            <PaginatedListFooter
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChange={setPage}
            />

          </CardContent>

        </Card>

      </main>

    </div>

  );

}


